import {
  ApiCartChangeCartPaymentModeFailedAction,
  ApiCartChangeCartPaymentModeSucceededAction,
  apiCartChangeCartPaymentModeFailedType,
  apiCartChangeCartPaymentModeRequested,
  apiCartChangeCartPaymentModeSucceededType
} from '../../api/cart/changeCartPaymentModeApi';
import {
  ChangeCurrentCartPaymentModeRequestedAction,
  changeCurrentCartPaymentModeFailed,
  changeCurrentCartPaymentModeSucceeded
} from '../../carts/cartsSlice';
import { put, race, take } from 'typed-redux-saga';
import { ChangeCartPaymentModeResult } from '../../../graphql/cart/changeCartPaymentMode';
import { CustomOrderType } from '@spa/lib/store/carts/CustomOrderType';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';

function* changeCurrentCartPaymentModeSaga({
  payload: { actionId: requestedActionId, customOrderType, paymentMode }
}: ChangeCurrentCartPaymentModeRequestedAction): Generator {
  const actionId: number = generateActionId();
  yield* put(
    apiCartChangeCartPaymentModeRequested({
      paymentMode,
      actionId,
      customOrderType,
      parentActionId: requestedActionId
    })
  );

  yield* actionsLoop(actionId, requestedActionId, customOrderType);
}

function* actionsLoop(
  actionId: number,
  requestedActionId: number,
  customOrderType: CustomOrderType
): Generator {
  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiCartChangeCartPaymentModeSucceededAction>(
        apiCartChangeCartPaymentModeSucceededType
      ),
      failed: take<ApiCartChangeCartPaymentModeFailedAction>(apiCartChangeCartPaymentModeFailedType)
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const result: ChangeCartPaymentModeResult = succeeded.payload.result;
        if (result.__typename === 'ChangeCartPaymentModeFailedResult') {
          yield* put(
            changeCurrentCartPaymentModeFailed({
              requestedActionId
            })
          );
        } else {
          yield* put(
            changeCurrentCartPaymentModeSucceeded({
              cart: convertCartToStateCart(result.cart),
              customOrderType,
              requestedActionId
            })
          );
        }
      } else if (failed !== undefined) {
        yield* put(
          changeCurrentCartPaymentModeFailed({
            requestedActionId
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default changeCurrentCartPaymentModeSaga;
